import React, { useState, useEffect } from "react";
import axios from "axios";
import { PiggyBank, Plus, Trash2, CheckCircle2, X, ArrowDownCircle, ArrowUpCircle, Calculator, Zap } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const KeuanganDanaCadanganPage = () => {
  const currentKode = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}`;
  const [data, setData] = useState({ items: [], saldo: 0, total_setoran: 0, total_penarikan: 0 });
  const [showAdd, setShowAdd] = useState(false);
  const [notif, setNotif] = useState("");
  const [periode, setPeriode] = useState(currentKode);
  const [rekom, setRekom] = useState(null);
  const [form, setForm] = useState({ jenis: "setoran", nominal: 500000, periode: currentKode, tanggal: new Date().toISOString().split("T")[0], keterangan: "" });

  const fetchData = async () => {
    const res = await axios.get(`${BACKEND_URL}/api/dana-cadangan`, { withCredentials: true });
    setData(res.data);
  };
  const fetchRekom = async (p) => {
    const res = await axios.get(`${BACKEND_URL}/api/dana-cadangan/rekomendasi?periode=${p}`, { withCredentials: true });
    setRekom(res.data);
  };
  useEffect(() => { fetchData(); }, []);
  useEffect(() => { fetchRekom(periode); }, [periode]);
  const notify = (m) => { setNotif(m); setTimeout(() => setNotif(""), 4000); };
  const rp = (n) => "Rp " + Number(n || 0).toLocaleString("id-ID");

  const refresh = () => { fetchData(); fetchRekom(periode); };

  const handleSave = async (e) => {
    e.preventDefault();
    await axios.post(`${BACKEND_URL}/api/dana-cadangan`, { ...form, nominal: Number(form.nominal) || 0 }, { withCredentials: true });
    setShowAdd(false);
    setForm({ jenis: "setoran", nominal: 500000, periode: currentKode, tanggal: new Date().toISOString().split("T")[0], keterangan: "" });
    refresh();
    notify("Transaksi dana cadangan berhasil dicatat!");
  };
  const handleSetorOtomatis = async () => {
    if (!rekom || rekom.kurang <= 0) return;
    await axios.post(`${BACKEND_URL}/api/dana-cadangan`, {
      jenis: "setoran", nominal: Math.round(rekom.kurang), periode,
      tanggal: new Date().toISOString().split("T")[0],
      keterangan: `Setoran otomatis ${rekom.persen}% dari omzet (${periode})`,
    }, { withCredentials: true });
    refresh();
    notify(`Setoran otomatis ${rp(Math.round(rekom.kurang))} berhasil dicatat!`);
  };
  const handleDelete = async (id) => {
    if (!window.confirm("Hapus transaksi ini?")) return;
    await axios.delete(`${BACKEND_URL}/api/dana-cadangan/${id}`, { withCredentials: true });
    refresh();
  };

  return (
    <div className="space-y-6" data-testid="dana-cadangan-page">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 p-5 rounded-2xl bg-[#0e1628] border border-slate-800 shadow-xl">
        <div>
          <span className="px-2 py-0.5 rounded bg-purple-500/20 text-purple-400 text-[10px] font-bold uppercase tracking-wider">Reserve Fund</span>
          <h1 className="text-xl sm:text-2xl font-black text-white mt-1">Dana Cadangan</h1>
          <p className="text-xs text-slate-400 mt-0.5">Kumpulkan dana cadangan setiap bulan untuk kebutuhan darurat & investasi.</p>
        </div>
        <button onClick={() => setShowAdd(true)} data-testid="add-dana-btn" className="px-4 py-2 bg-gradient-to-r from-purple-600 to-fuchsia-600 hover:from-purple-500 hover:to-fuchsia-500 text-white text-xs font-bold rounded-xl shadow-lg shadow-purple-600/30 flex items-center gap-2">
          <Plus className="w-4 h-4" /> Tambah Transaksi
        </button>
      </div>

      {notif && <div className="p-3 bg-purple-500/10 border border-purple-500/30 text-purple-300 rounded-xl text-xs flex items-center gap-2"><CheckCircle2 className="w-4 h-4" /> {notif}</div>}

      {/* Rekomendasi otomatis dari Manajemen Operasional */}
      {rekom && (
        <div className="p-5 rounded-2xl bg-gradient-to-br from-fuchsia-900/30 to-purple-900/10 border border-fuchsia-500/40 shadow-xl" data-testid="dana-rekomendasi">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
            <div className="flex items-start gap-3">
              <Calculator className="w-5 h-5 text-fuchsia-300 mt-0.5" />
              <div>
                <h3 className="text-sm font-bold text-white">Rekomendasi Dana Cadangan Otomatis</h3>
                <p className="text-[11px] text-slate-400 mt-0.5">Dihitung dari <b className="text-fuchsia-300">{rekom.persen}%</b> omzet (sesuai Manajemen Operasional) × pendapatan {rp(rekom.pendapatan)}.</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <select value={periode} onChange={(e) => setPeriode(e.target.value)} data-testid="dana-periode" className="px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-200 font-semibold">
                {Array.from({ length: 6 }).map((_, idx) => {
                  const d = new Date(); d.setMonth(d.getMonth() - 3 + idx);
                  const kode = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
                  return <option key={kode} value={kode}>{d.toLocaleDateString("id-ID", { month: "long", year: "numeric" })}</option>;
                })}
              </select>
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-4">
            <div className="p-3 rounded-xl bg-slate-950/60"><p className="text-[11px] text-slate-400">Rekomendasi Setoran</p><p className="text-lg font-black text-fuchsia-300 mt-1 font-mono">{rp(rekom.rekomendasi)}</p></div>
            <div className="p-3 rounded-xl bg-slate-950/60"><p className="text-[11px] text-slate-400">Sudah Disetor Periode Ini</p><p className="text-lg font-black text-emerald-400 mt-1 font-mono">{rp(rekom.sudah_disetor)}</p></div>
            <div className="p-3 rounded-xl bg-slate-950/60"><p className="text-[11px] text-slate-400">Kekurangan Setoran</p><p className="text-lg font-black text-amber-400 mt-1 font-mono">{rp(rekom.kurang)}</p></div>
            <button onClick={handleSetorOtomatis} disabled={rekom.kurang <= 0} data-testid="setor-otomatis-btn" className="p-3 rounded-xl bg-gradient-to-r from-fuchsia-600 to-purple-600 hover:from-fuchsia-500 hover:to-purple-500 text-white text-xs font-bold flex flex-col items-center justify-center gap-1 disabled:opacity-40 disabled:cursor-not-allowed">
              <Zap className="w-4 h-4" />
              {rekom.kurang > 0 ? `Setor Otomatis ${rp(Math.round(rekom.kurang))}` : "Target Tercapai ✓"}
            </button>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="p-5 rounded-2xl bg-gradient-to-br from-purple-600/20 to-fuchsia-600/10 border border-purple-500/30 md:col-span-1">
          <p className="text-[11px] text-purple-300 uppercase font-bold tracking-wider flex items-center gap-1.5"><PiggyBank className="w-4 h-4" /> Saldo Dana Cadangan</p>
          <p className="text-2xl font-black text-white mt-2 font-mono" data-testid="dana-saldo">{rp(data.saldo)}</p>
        </div>
        <div className="p-4 rounded-2xl bg-[#0e1628] border border-slate-800"><p className="text-[11px] text-slate-400">Total Setoran</p><p className="text-lg font-black text-emerald-400 mt-1 font-mono">{rp(data.total_setoran)}</p></div>
        <div className="p-4 rounded-2xl bg-[#0e1628] border border-slate-800"><p className="text-[11px] text-slate-400">Total Penarikan</p><p className="text-lg font-black text-rose-400 mt-1 font-mono">{rp(data.total_penarikan)}</p></div>
      </div>

      <div className="p-5 rounded-2xl bg-[#0e1628] border border-slate-800 shadow-xl overflow-x-auto">
        <table className="w-full text-left text-xs">
          <thead><tr className="border-b border-slate-800 text-slate-400 font-semibold">
            <th className="py-2.5 px-3">Tanggal</th><th className="py-2.5 px-3">Periode</th><th className="py-2.5 px-3">Jenis</th><th className="py-2.5 px-3">Keterangan</th><th className="py-2.5 px-3">Nominal</th><th className="py-2.5 px-3 text-right">Aksi</th>
          </tr></thead>
          <tbody className="divide-y divide-slate-800/60">
            {data.items.length === 0 && <tr><td colSpan={6} className="py-6 text-center text-slate-500">Belum ada transaksi dana cadangan.</td></tr>}
            {data.items.map((i) => (
              <tr key={i.id} className="hover:bg-slate-900/40" data-testid={`dana-row-${i.id}`}>
                <td className="py-3 px-3 text-slate-300">{i.tanggal}</td>
                <td className="py-3 px-3 text-slate-400">{i.periode}</td>
                <td className="py-3 px-3">
                  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold ${i.jenis === "setoran" ? "bg-emerald-500/20 text-emerald-300" : "bg-rose-500/20 text-rose-300"}`}>
                    {i.jenis === "setoran" ? <ArrowDownCircle className="w-3 h-3" /> : <ArrowUpCircle className="w-3 h-3" />}{i.jenis === "setoran" ? "SETORAN" : "PENARIKAN"}
                  </span>
                </td>
                <td className="py-3 px-3 text-slate-300">{i.keterangan || "-"}</td>
                <td className={`py-3 px-3 font-mono font-bold ${i.jenis === "setoran" ? "text-emerald-400" : "text-rose-400"}`}>{i.jenis === "setoran" ? "+" : "-"} {rp(i.nominal)}</td>
                <td className="py-3 px-3 text-right"><button onClick={() => handleDelete(i.id)} className="p-1.5 text-rose-400 hover:bg-rose-950/60 rounded-lg"><Trash2 className="w-3.5 h-3.5" /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showAdd && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-[#0f172a] border border-slate-700 rounded-2xl w-full max-w-md shadow-2xl p-5 space-y-4">
            <div className="flex justify-between items-center border-b border-slate-800 pb-3">
              <h3 className="text-sm font-bold text-white">Transaksi Dana Cadangan</h3>
              <button onClick={() => setShowAdd(false)} className="text-slate-400"><X className="w-4 h-4" /></button>
            </div>
            <form onSubmit={handleSave} className="space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <div><label className="block text-xs text-slate-300 mb-1">Jenis</label>
                  <select value={form.jenis} onChange={(e) => setForm({ ...form, jenis: e.target.value })} data-testid="dana-jenis-select" className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100">
                    <option value="setoran">Setoran (menambah saldo)</option><option value="penarikan">Penarikan (mengurangi saldo)</option>
                  </select>
                </div>
                <div><label className="block text-xs text-slate-300 mb-1">Nominal (Rp) *</label><input required type="number" value={form.nominal} onChange={(e) => setForm({ ...form, nominal: e.target.value })} data-testid="dana-nominal-input" className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100 font-mono" /></div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div><label className="block text-xs text-slate-300 mb-1">Periode</label><input type="month" value={form.periode} onChange={(e) => setForm({ ...form, periode: e.target.value })} className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100" /></div>
                <div><label className="block text-xs text-slate-300 mb-1">Tanggal</label><input type="date" value={form.tanggal} onChange={(e) => setForm({ ...form, tanggal: e.target.value })} className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100" /></div>
              </div>
              <div><label className="block text-xs text-slate-300 mb-1">Keterangan</label><input type="text" value={form.keterangan} onChange={(e) => setForm({ ...form, keterangan: e.target.value })} placeholder="Contoh: Setoran cadangan bulanan" className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100" /></div>
              <div className="pt-1 flex justify-end gap-2">
                <button type="button" onClick={() => setShowAdd(false)} className="px-3 py-1.5 bg-slate-800 text-slate-300 rounded-xl text-xs">Batal</button>
                <button type="submit" data-testid="save-dana-btn" className="px-4 py-1.5 bg-purple-600 text-white rounded-xl text-xs font-bold">Simpan</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};
